import LegalShell from '../components/layout/LegalShell';

export default function LegalNotice() {
  return (
    <LegalShell eyebrow="Información legal" title="Aviso legal">
      <div className="legal-notice" role="note">
        Documento pendiente de revisión jurídica y de completar con los datos
        reales de la titular antes de publicar la web.
      </div>

      <section>
        <h2>1. Identificación de la titular</h2>
        <p>
          <strong>Titular:</strong> [RAZÓN SOCIAL PENDIENTE]
          <br />
          <strong>NIF:</strong> [NIF PENDIENTE]
          <br />
          <strong>Domicilio:</strong> [DOMICILIO PENDIENTE]
          <br />
          <strong>Correo electrónico:</strong> [EMAIL PENDIENTE]
        </p>
      </section>

      <section>
        <h2>2. Objeto</h2>
        <p>
          Este sitio presenta de forma informativa la marca Evolution by Corina
          y permite enviar una solicitud de contacto. Las condiciones concretas
          de cualquier servicio deberán facilitarse y aceptarse por separado.
        </p>
      </section>

      <section>
        <h2>3. Contenidos y responsabilidad</h2>
        <p>
          Los contenidos de esta versión son informativos y algunos textos están
          expresamente identificados como pendientes. No sustituyen la valoración
          individual de profesionales sanitarios ni constituyen una promesa de
          resultados.
        </p>
      </section>

      <section>
        <h2>4. Propiedad intelectual</h2>
        <p>
          El uso del logotipo, textos, fotografías y demás contenidos queda
          sujeto a los derechos de sus titulares. Los créditos y licencias de
          las imágenes provisionales deben revisarse al incorporar las
          fotografías definitivas.
        </p>
      </section>

      <section>
        <h2>5. Legislación aplicable</h2>
        <p>[LEGISLACIÓN Y JURISDICCIÓN PENDIENTES DE REVISIÓN JURÍDICA]</p>
      </section>
    </LegalShell>
  );
}
